/* global axios */
import ApiClient from './ApiClient';

class LuckyDrawAPI extends ApiClient {
  constructor() {
    super('contacts', { accountScoped: true });
  }

  // 1. Register for Lucky Draw
  updateLuckyDraw({ id, ...data }) {
    return axios.patch(`${this.url}/${id}/update_lucky_draw`, data);
  }

  // 2. List Lucky Draw Participants
  getParticipants({ page = 1, filter = 'all', q = '', registered_from, registered_to } = {}) {
    return axios.get(`${this.url}/lucky_draw_participants`, {
      params: {
        page,
        filter,
        q,
        registered_from,
        registered_to,
      },
    });
  }

  // 3. Auto-select 3 Winners
  autoSelectWinners() {
    return axios.post(`${this.url}/lucky_draw_select_winners`);
  }

  // 4. Manually Mark Winner (Single)
  markAsWinner({ id }) {
    return axios.post(`${this.url}/${id}/mark_as_winner`);
  }

  // 5. Manually Mark Winners (Bulk)
  markAsWinners({ contact_ids }) {
    return axios.post(`${this.url}/mark_as_winners`, { contact_ids });
  }

  // 6. Clear All Winners
  clearWinners() {
    return axios.delete(`${this.url}/lucky_draw_clear_winners`);
  }
}

export default new LuckyDrawAPI();
